//Devices page
export const NUM_DEVICES_PER_PAGE = 20;
export const DEVICE_MODEL_REANIBEX = "Reanibex 100";
export const DEVICE_MODEL_R100 = "R100";
export const DEVICE_SIM_STATUS_ENABLE = "active";
export const DEVICE_PROGRAM_TYPE_EMT = 2;

//Device tracking status
export const DEVICE_TRACKING_STATUS_CONFIGURED = "configured";
export const DEVICE_TRACKING_STATUS_ACTIVE = "active";
export const DEVICE_TRACKING_STATUS_EXTRACTED = "extracted";
export const DEVICE_TRACKING_STATUS_MAINTENANCE = "maintenance";
export const DEVICE_TRACKING_STATUS_IN_USE = "in_use";
export const DEVICE_TRACKING_STATUS_NO_SIGNAL = "no_signal";
export const DEVICE_TRACKING_STATUS_PROCESS_DISCARTED = "process_discarted";

//Operational_incident_status
export const DEVICE_OPERATIONAL_INCIDENT_STATUS_ACTIVE = 2;
export const DEVICE_OPERATIONAL_INCIDENT_STATUS_IN_USE = 3;
export const DEVICE_OPERATIONAL_INCIDENT_STATUS_EXTRACTED = 4;
export const DEVICE_OPERATIONAL_INCIDENT_STATUS_MAINTENANCE = 5;
export const DEVICE_OPERATIONAL_INCIDENT_STATUS_NO_SIGNAL = 6;
export const DEVICE_OPERATIONAL_INCIDENT_STATUS_PROCESS_DISCARTED = 7;

// Tracker operational incident lifecycle.
// Valores definidos en TrackerOperationalIncidentStatus.cs.
export const TRACKER_OPERATIONAL_INCIDENT_STATUS = {
  ACTIVE: 1,
  PENDING_OPERATIONAL_CLOSURE: 2,
  CLOSED: 3,
  NEEDS_MANUAL_CLOSURE: 4,
  READY_FOR_OPERATIONAL_CLOSURE: 5
};
